/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link, EagerLoadImages } from "@quintype/components";
import get from "lodash/get";

import { AdContainer } from "../../ads";
import { getCollection, filterStory, filterCollection } from "../../helper/api";

import StoryCard1 from "../../molecules/story-card1";
import StoryCard2 from "../../molecules/story-card2";
import StoryCard3 from "../../molecules/story-card3";
import StoryCard4 from "../../molecules/story-card4";

import CardImage from "../../atoms/cardimage";

import "./top-stories.m.css";
import MobileCollection from "../mobile-collection";
import Arrow from "../../atoms/other-icons/Arrow";

const collectionWidgetHardcode = `<style>   /* Default iframe style for desktop */   .responsive-iframe {     width: 100%;     height: 60px; /* Default height for desktop */     border: none;     overflow: hidden;   }    /* Adjust height for mobile devices */   @media (max-width: 767px) {     .responsive-iframe {       height: 85px; /* Adjusted height for mobile */     }   } </style>  <iframe style="overflow: hidden;"      class="responsive-iframe"      src="https://tpml-sites.s3.ap-south-1.amazonaws.com/mh-widgets.html"      allowfullscreen> </iframe>`;

const TopStories = ({ collection }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);
  const subashithaCollection = filterCollection(collection)[0];
  const subashithaStory = subashithaCollection && subashithaCollection.items[0] && subashithaCollection.items[0].story;

  if (!stories.length) {
    return null;
  }

  const [brandspotStories, setBrandspotStories] = useState([]);
  const useBrandspotStories = get(collection, ["metadata", "brand-spot"], false);

  useEffect(() => {
    if (["true", "True", "t", "T"].includes(useBrandspotStories)) {
      getCollection("brandspot-collection").then((resp) => setBrandspotStories(resp));
    } else {
      setBrandspotStories([]);
    }
  }, []);

  brandspotStories[0] && stories.splice(4, 0, brandspotStories[0]);
  brandspotStories[1] && stories.splice(9, 0, brandspotStories[1]);

  return (
    <>
      {/* <div styleName="collection-widget-wrapper" dangerouslySetInnerHTML={{ __html: collectionWidgetHardcode }}></div> */}
      <div styleName="wrapper" className="hide-mobile">
        <div styleName="col-1">
          {stories?.splice(0, 1).map((item, index) => (
            <React.Fragment key={item?.id}>
              <EagerLoadImages>
                <StoryCard1 story={item} />
              </EagerLoadImages>
            </React.Fragment>
          ))}
          <div styleName="col1-sub">
            <div styleName="col1-sub-stories sub1">
              {stories?.splice(0, 2).map((item, index) => (
                <StoryCard2 story={item} key={item?.id} />
              ))}
            </div>
            <div styleName="col1-sub-stories sub2">
              {stories?.splice(0, 2).map((item, index) => (
                <StoryCard2 story={item} key={item?.id} />
              ))}
            </div>
          </div>
        </div>
        <div styleName="col-2">
          {stories?.splice(0, 1).map((i, index) => (
            <StoryCard4 story={i} key={i?.id} />
          ))}
          {stories?.splice(0, 2).map((i, index) => (
            <StoryCard3 story={i} key={i?.id} />
          ))}
          {stories?.splice(0, 1).map((i, index) => (
            <StoryCard4 story={i} key={i?.id} />
          ))}
          {stories?.splice(0, 2).map((i, index) => (
            <StoryCard3 story={i} key={i?.id} />
          ))}
        </div>
        <div styleName="col-3">
          <div styleName="ad-wrapper" className="hide-mobile">
            <AdContainer AdClassName="standard-300x250" id="div-gpt-ad-1675836921322-0" desktop="PV_Desktop_HP_RT" />
          </div>
          {subashithaStory && (
            <div styleName="subashitha-card">
              <Link href={`/${subashithaStory.slug}`}>
                <CardImage story={subashithaStory} aspectRatio={[16, 9]} imageType="image16x9" widths={[360]} />
              </Link>
            </div>
          )}
          {stories[0] && stories[0]?.sections[0] && (
            <Link styleName="seemore" href={`/news`}>
              ಇನ್ನಷ್ಟು
              <Arrow color="#b82831" width="16px" height="12px" />
            </Link>
          )}
          {stories?.splice(0, 4).map((item, index) => (
            <StoryCard4 story={item} key={item?.id} />
          ))}
        </div>
      </div>
      <div className="hide-desktop">
        <MobileCollection collection={collection} />
      </div>
    </>
  );
};

export default TopStories;
